<template>
  <div class="footer-container">
    <div class="wrapper info">
      Copyright©中国汽车流通协会 | 备案号：京ICP备09041733号-3
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/variable.scss';
.footer-container {
  position: absolute;
  bottom: 0px;
  height: 80px;
  width: 100%;
  background: $baseColor;
  color: #fff;
  .info {
    font-size: 16px;
    text-align: center;
    line-height: 80px;
  }
}
</style>
